module.exports = __webpack_public_path__ + "img/question.842f84a2.svg";